import { apiObject } from './apiobject'
import axios from 'axios'

const keywords = {
  ...apiObject,
  url: '/keywords/',
  getProjectKeywords(project_id) {
    return axios.get(this.url, { params: { project: project_id } })
      .then(r => r.data.results)
  },
}

export default { keywords }
